import React from 'react';
import PropTypes from 'prop-types';

export default function UnsafeHtml({ children, tag: Tag, ...restProps }) {
  const unsafeContent = {
    __html: children,
  };
  return <Tag dangerouslySetInnerHTML={unsafeContent} {...restProps} />;
}

UnsafeHtml.defaultProps = {
  tag: 'span',
};

UnsafeHtml.propTypes = {
  tag: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/app/ui/core/common/UnsafeHtml.js